import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
import { ITask, IUpdateTask } from '../interface/tasks';
import { IAPIError } from '../interface/common';
import { useAnalytics } from './useAnalytics';
import { AnalyticsFeatureOperation } from '../interface/analytics';

const createTask = async (
  taskData: IUpdateTask,
  params: Record<string, string>,
): Promise<ITask> => {
  return post(`${API_URLS.TASKS_LIST}`, taskData, { params, skipGlobalErrorHandler: true });
};

export const useCreateTask = (): UseMutationResult<
  ITask,
  AxiosError<IAPIError>,
  { taskData: IUpdateTask; params: Record<string, string> }
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: ({ taskData, params }) => createTask(taskData, params),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.TASK_CREATION);
      showToast('success', t('task:successfullyCreated'));
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
